module.exports = __webpack_public_path__ + "static/media/project-thumbnail09.6f994e51.jpg";